"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PartnersList;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _LiveWidget = require("./LiveWidget");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 10px;\n  right: 10px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  p {\n    padding: 0 0 30px;\n    line-height: 1.4;\n    min-height: 80px;\n    color: white;\n  }\n\n  h2 {\n    color: #585858;\n    font-size: 18px;\n    margin: 0 0 15px 0;\n    font-weight: 400;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 130px;\n  display: flex;\n  padding: 0;\n\n  @media (min-width: 768px) {\n    height: 180px;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n    max-height: 80px;\n    margin: auto;\n\n    @media (min-width: 768px) {\n      max-height: 100px;\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  font-size: 16px;\n  border: 4px solid #131311;\n  padding: 0 ", ";\n  margin-bottom: 10px;\n  text-decoration: none;\n  text-align: center;\n  position: relative;\n\n  @media (min-width: 768px) {\n    font-size: 18px;\n    margin-bottom: 20px;\n    width: 40%;\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n\n  @media (min-width: 1400px) {\n    width: 25%;\n  }\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:hover ", " {\n    background: white;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 -", ";\n  padding: 15px 0;\n  text-align: center;\n  text-transform: uppercase;\n  color: black;\n  background: #fef502;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 0 auto;\n  padding: 10px;\n  justify-content: center;\n  flex-direction: column;\n\n  @media (min-width: 768px) {\n    flex-direction: row;\n    flex-wrap: wrap;\n    padding: 20px;\n  }\n\n  @media (min-width: 1400px) {\n    padding: 100px 60px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents.default.div(_templateObject());

var itemMargin = '40px';

var CtaButton = _styledComponents.default.div(_templateObject2(), itemMargin);

var Item = (0, _styledComponents.default)(_reactRouterDom.Link)(_templateObject3(), itemMargin, CtaButton);

var ImgWrapper = _styledComponents.default.div(_templateObject4());

var Description = _styledComponents.default.div(_templateObject5());

var LiveWidgetContainer = _styledComponents.default.div(_templateObject6());

function PartnersList(_ref) {
  var partners = _ref.partners,
      loading = _ref.loading;
  return /*#__PURE__*/_react.default.createElement(Container, null, loading ? /*#__PURE__*/_react.default.createElement("div", null, "Loading...") : Object.keys(partners).map(function (partner, i) {
    var _partners$partner = partners[partner],
        name = _partners$partner.name,
        description = _partners$partner.description,
        logo = _partners$partner.logo,
        isLive = _partners$partner.isLive;
    return /*#__PURE__*/_react.default.createElement(Item, {
      to: "/booth/".concat(partner),
      key: i
    }, isLive ? /*#__PURE__*/_react.default.createElement(LiveWidgetContainer, null, /*#__PURE__*/_react.default.createElement(_LiveWidget.LiveWidget, null, "Live")) : null, /*#__PURE__*/_react.default.createElement(ImgWrapper, null, /*#__PURE__*/_react.default.createElement("img", {
      src: logo
    })), /*#__PURE__*/_react.default.createElement(Description, null, /*#__PURE__*/_react.default.createElement("p", null, description)), /*#__PURE__*/_react.default.createElement(CtaButton, null, "Visit"));
  }));
}